<template>
    <div>
		<el-alert type="warning" :closable="false">
			<div slot="title">
				<router-link to="/operation/banner/listcalendar" class="color-danger">切换到月历视图<i class="el-icon-right"></i></router-link>
			</div>
		</el-alert>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="BannerID" :value="1"></el-option>
                            <el-option label="Banner名称" :value="2"></el-option>
                            <el-option label="展示城市" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="12" :xl="2">
					<el-select v-model="params.queryTimeType"  placeholder="请选择" size="small">
					    <el-option label="展示时间" :value="1"></el-option>
					    <el-option label="展示起始时间" :value="2"></el-option>
					</el-select>
                    <!-- <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                           
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            class="fl"
                            size="small">
                        </el-date-picker>
                    </div> -->
                </el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" >
					<el-date-picker
						  size="small"
					      v-model="params.startTime"
					      type="datetime"
					      placeholder="开始日期"
						  value-format="yyyy-MM-dd HH:mm:ss">
					    </el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" >
					<el-date-picker
						 size="small"
					      v-model="params.endTime"
					      type="datetime"
					      placeholder="结束日期"
						  value-format="yyyy-MM-dd HH:mm:ss">
					    </el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.category" placeholder="不限制位于首页分类的位置" class="fl fl-big-select" clearable size="small">
						<el-option v-for="(item, index) in category"  :label="item.name == '推荐' ? '位于首页推荐分类' : '仅看位于首页'+item.name+'分类的' " :key="index" :value="item.id"></el-option>
					</el-select>
				 </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isShow" placeholder="请选择" size="small">
                        <el-option label="仅看展示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="2"></el-option>
                        <el-option label="不限制状态" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.terminal" placeholder="请选择" size="small">
                        <el-option label="仅看APP的" :value="3"></el-option>
                        <el-option label="仅看WAPCN的" :value="2"></el-option>
                        <el-option label="仅看WAPEN的" :value="4"></el-option>
                        <el-option label="仅看WEB的" :value="1"></el-option>
                        <el-option label="不限制展示终端" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/banner/getDetail')"
                type="primary"
                icon="el-icon-plus"
                @click="add"
                size="small"
                >创建Banner</el-button
            >
            <el-button
                v-if="$utils.have('/banner/sort')"
                type="primary"
                icon="el-icon-sort"
                @click="visible = true;"
                size="small"
                >排序管理</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
            >
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.isShow === 1">展示</p>
                        <p v-else-if="scope.row.isShow === 2">隐藏</p>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column label="名称" min-width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis" :href="scope.row.url" type="primary" target="_blank">{{ scope.row.title }}</el-link>
                    </template>
                </el-table-column>
				<el-table-column prop="categoryView" label="演出分类"></el-table-column>
                <el-table-column label="展示城市">
                    <template slot-scope="scope">
                        <p v-if="scope.row.cityCode === 0">全国</p>
                        <p v-else>{{ scope.row.cityName }}</p>
                    </template>
                </el-table-column>
				<el-table-column label="订单转化" min-width="120">
				    <template slot-scope="scope">
				       <p>下单人数：<span v-if="scope.row.orderUserCount">{{ scope.row.orderUserCount }}</span></p>
				       <p>转化率：<span v-if="scope.row.orderCr">{{ scope.row.orderCr }}%</span></p>
				    </template>
				</el-table-column>
				<el-table-column label="订单">
				    <template slot-scope="scope">
				       <p>订单数：<span v-if="scope.row.orderCount">{{ scope.row.orderCount }}</span></p>
				       <p>销售额：<span v-if="scope.row.saleAmountView">{{ scope.row.saleAmountView }}</span></p>
				    </template>
				</el-table-column>
                <el-table-column prop="rate" label="城市序号"></el-table-column>
                <el-table-column label="展示终端" min-width="120">
                    <template slot-scope="scope">
                        <p>{{ showTerminal(scope.row.terminal) }}</p>
                    </template>
                </el-table-column>
                <el-table-column width="175" label="展示时间段1">
                    <template slot-scope="scope">
                        <p v-if="scope.row.startDate">起：{{ scope.row.startDate }}</p>
                        <p v-if="scope.row.autoDeleteTime">止：{{ scope.row.autoDeleteTime }}</p>
                    </template>
                </el-table-column>
                <el-table-column width="175" label="展示时间段2">
                    <template slot-scope="scope">
                        <p v-if="scope.row.firstStartDate">起：{{ scope.row.firstStartDate }}</p>
                        <p v-if="scope.row.firstEndDate">止：{{ scope.row.firstEndDate }}</p>
                    </template>
                </el-table-column>
                <el-table-column width="175" label="展示时间段3">
                    <template slot-scope="scope">
                        <p v-if="scope.row.secondStartDate">起：{{ scope.row.secondStartDate }}</p>
                        <p v-if="scope.row.secondEndDate">止：{{ scope.row.secondEndDate }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="appClickNum" label="APP点击量" min-width="90"></el-table-column>
                <el-table-column prop="wapClickNum" label="WAP点击量" min-width="90"></el-table-column>
                <el-table-column prop="webClickNum" label="WEB点击量" min-width="90"></el-table-column>
                <el-table-column fixed="right" min-width="200" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >管理</el-button
                        >
                        <el-button
                            v-if="scope.row.cityCode === 0"
                            type="text"
                            size="small"
                            icon="el-icon-sort"
                            @click="setTop(scope.row.id, scope.row.isTop === 1 ? 0 : 1)"
                            >{{ scope.row.isTop === 0 ? '设为全国优先展示' : '设为全国置后展示' }}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
        <sort :visible.sync="visible"></sort>
    </div>
</template>

<script>
import Sort from './components/sort';
const defaultQuery = {
    pageNo: 1,
    endTime: '',
    startTime: '',
    queryTimeType: 1,
    queryType: 1,
    queryValue: '',
    terminal: '',
    isShow: '',
	category:''
};
export default {
    components: {
        Sort
    },
    data() {
        return {
            visible: false,
            params: {
                ...defaultQuery,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                // startTime: this.$route.query.startTime || '',
                // endTime: this.$route.query.endTime || '',
                queryTimeType: parseInt(this.$route.query.queryTimeType || 1),
                queryType: parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue || '',
                terminal: parseInt(this.$route.query.terminal)|| '',
                isShow: parseInt(this.$route.query.isShow)|| '',
				category: parseInt(this.$route.query.category)|| '',
            },
           // datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            fetchLoading: false,
            tableData: [],
			category:[],
            totalCount: 0,
        };
    },
    mounted(){
		this.getCategory()
        this.fetch();
    },
    methods: {
        showTerminal (str) {
            const name = ['WEB', 'WAPCN', 'APP', 'WAPEN'];
            return str.split(',').map(item => name[item - 1]).toString().replace(/,/g, "/");
        },
		//获取演出分类
		getCategory() {
		    this.$request({
		        url: "/banner/category",
		        method: "post",
		        
		    }).then(res => {
		        const { state, result } = res.data;
		        if (state == 1) {
		            this.category = result || []
		        }
		    })
		},
        async fetch() {
            if( this.$utils.compareDate(this.params.startTime, this.params.endTime) ){
                return this.$message.error("开始时间不能大于等于结束时间");
            }
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/banner/getPageList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.tableData = result.result;
            this.totalCount = result.totalCount;
        },
        async setTop (id, type) {
            const response = await this.$request({
                url: '/banner/setAsNationalSort',
                params: {id, type},
            });
            const {msg, state} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.$message.success('操作成功');
            this.fetch();
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.fetch();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultQuery,
                pageSize: this.params.pageSize,
            };
            this.fetch();
        },
        add(){
            this.$router.push('/operation/banner/add');
        },
        edit(id){
            this.$router.push({
                path:`/operation/banner/detail/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    },
};
</script>
<style lang="scss" scoped>
</style>